import { useStaticQuery, graphql } from 'gatsby'
import React from 'react'
import loadable from '@loadable/component'

const Availability = loadable(() => import('../Availability'))

const PhoneNumber = () => {
  const data = useStaticQuery(graphql`
    query {
      globalHeader: sanityGlobalHeader {
        tel
      }
    }
  `)

  const { tel } = data.globalHeader

  return (
    <div className="leading-4">
      <a className="text-12 md:text-14" href={`tel:${tel}`}>
        {tel}
      </a>
      <br />
      <Availability />
    </div>
  )
}

export default PhoneNumber
